import { Typography } from "@kyan/ui";

import type { LiquidationWarningVariant } from "#/store/app/liquidationWarnings/liquidationWarnings.types";
import { type UnderlyingSymbol } from "#/types/markets";
import { formatPercent } from "#/utils/valueFormatters";

export const createTitle = (
  symbol: UnderlyingSymbol,
  variant: LiquidationWarningVariant,
) => {
  return variant === "warning"
    ? `Liquidation Warning for ${symbol} Portfolio`
    : `Liquidation`;
};

export const createDescription = ({
  symbol,
  variant,
  mmr = 0,
  isToast = false,
}: {
  symbol: UnderlyingSymbol;
  variant: LiquidationWarningVariant;
  mmr?: number;
  isToast?: boolean;
}) => {
  if (variant === "warning") {
    return (
      <Typography primary size={12} element="p">
        <Typography>MMr: </Typography>
        <Typography>
          {formatPercent(mmr, { precision: 2, signDisplay: "never" })}
        </Typography>
      </Typography>
    );
  }

  const liquidatingText = (
    <Typography>
      Your <Typography weight="bold">{symbol} portfolio </Typography>
      is under liquidation!{" "}
    </Typography>
  );
  const tradesAndWithdrawsDisabledText = (
    <Typography>
      Trades and withdraws are{" "}
      <Typography weight="bold">temporarily disabled </Typography> until
      liquidation is complete.{" "}
    </Typography>
  );
  const depositFundsText = (
    <Typography>
      Deposit funds to restore equity and stop further liquidation.
    </Typography>
  );
  const toastContent = (
    <>
      {liquidatingText}
      <br />
      {depositFundsText}
    </>
  );
  const alertContent = (
    <>
      {liquidatingText}
      {tradesAndWithdrawsDisabledText}
      {depositFundsText}
    </>
  );

  return (
    <Typography primary size={12} element="p">
      {isToast ? toastContent : alertContent}
    </Typography>
  );
};
